module.exports = ".venue-field-guidance{\n    margin-bottom: 15px;\n    padding-left: 60px;\n    font-size: 12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/venues/components/base.css
// module id = ./src/app/organization/components/venues/components/base.css
// module chunks = main